import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { NoContentStubComponent } from '@core/components/no-content-stub/no-content-stub.component';
import { PaginationModule } from '@core/components/pagination/pagination.module';
import { SpinnersModule } from '@core/components/spinners/spinners.module';
import { CoreModule } from '@core/core.module';
import { TranslateModule } from '@ngx-translate/core';

// модули
import { ComplaintFormModule } from '@shared/complaint-form/complaint-form.module';

// компоненты
import { UserCardMiniModule } from './user-card-mini/user-card-mini.module';
import { UsersComponent } from './users/users.component';
import { UsersFormService } from './users-form.service';
import { UsersSidebarComponent } from './users-sidebar/users-sidebar.component';

// сервисы

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CoreModule,
    TranslateModule,
    FormsModule,
    ModalModule,
    SpinnersModule,
    PaginationModule,
    ReactiveFormsModule,
    ComplaintFormModule,
    MobileModalModule,
    NoContentStubComponent,
    UserCardMiniModule,
  ],
  exports: [UsersSidebarComponent, UserCardMiniModule],
  declarations: [UsersSidebarComponent, UsersComponent],
  providers: [UsersFormService],
})
export class UsersModule {}
